import { Sheet, SheetContent } from "@/components/ui/sheet";
import { BankAccountDetailsContent } from "./BankAccountDetailsContent";

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export const CreateBankAccountLinkSheet = ({ isOpen, onClose }: Props) => {
  const handleClose = () => onClose();

  return (
    <Sheet open={isOpen}>
      <SheetContent onClose={handleClose}>
        <BankAccountDetailsContent onClose={onClose} />
      </SheetContent>
    </Sheet>
  );
};
